<template>
    <div v-if="previsao_futura.Lancamentos.length != 0">
        <div class="row">
            <div class="sm-12">
                <div class="title">
                    <h2>Previsão Futura</h2>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="sm-12">
                <!--<p>04/01/2021</p>-->
                <div class="responsive-table">
                    <table>
                        <thead>
                            <tr>
                                <th width="80">Data</th>
                                <th>Histórico</th>
                                <th width="95">Valor</th>
                                <th width="30"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <Lancamento :previsao="true" :lancamento="lancamento" v-for="lancamento in previsao_futura.Lancamentos" :key="lancamento.id"></Lancamento>
                            <tr>
                                <td colspan="2" align="right">
                                    <b>Total</b>
                                </td>
                                <td align="right">
                                <b class="text-red" v-raw>{{ -previsao_futura.Totalizacao | number_format }}</b> 
                                </td>
                                <td align="center" class="text-red">D</td>
                            </tr>
                        </tbody>
                    </table>

                </div>

            </div>
        </div>
    </div>
</template>
<script>
import Lancamento from './lancamento.vue';
import Card from '../../../components/Card.vue';
export default {
    props: ["previsao_futura"],
    filters: {
        number_format(value) {
            let sign = '';
            if (value < 0) {
                sign = '<b class="number-sign">-</b>'
            }
            let str = sign + new Intl.NumberFormat("pt-BR", {
                currencySign: 'accounting',
                //currencySign: 'standard',
                style: "decimal",
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(Math.abs(value));

            return str;
        },
    },
    components: {
        Lancamento,
        Card
    }
};
</script>